import http from '@/communication/AuthConnection'

export default async ({ commit }, payload) => {
  try {
    const request = await http.post('/v1/board/task/open', payload)
    return request.data
  } catch (error) {
    return Promise.reject(error)
  }
}



// WEBPACK FOOTER //
// ./src/brain/board/open-task/index.js